import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { LayoutDashboard, Users, Package, CreditCard, Palette, Settings, Code, Megaphone, Briefcase, Flag } from 'lucide-react';
import DashboardTab from '../components/admin/DashboardTab';
import UsersTab from '../components/admin/UsersTab';
import ItemsTab from '../components/admin/ItemsTab';
import TransactionsTab from '../components/admin/TransactionsTab';
import ThemesTab from '../components/admin/ThemesTab';
import SettingsTab from '../components/admin/SettingsTab';
import APIToolsTab from '../components/admin/APIToolsTab';
import PromosTab from '../components/admin/PromosTab';
import ReportsTab from '../components/admin/ReportsTab';
import AdminBusinessApplications from './AdminBusinessApplications';

const AdminDashboard = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: 'calc(100vh - 70px)', position: 'relative', overflowX: 'hidden' }}>
      {/* Mobile Menu Button */}
      {isMobile && (
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          style={{
            position: 'fixed',
            top: '80px',
            left: '16px',
            zIndex: 1001,
            background: 'var(--primary)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '8px 12px',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          }}
        >
          ☰ Menu
        </button>
      )}

      {/* Sidebar */}
      <aside style={{
        width: isMobile ? '100%' : '250px',
        maxWidth: isMobile ? '280px' : '250px',
        background: 'var(--cardBackground)',
        borderRight: '1px solid var(--border)',
        padding: '24px 0',
        position: isMobile ? 'fixed' : 'relative',
        left: isMobile ? (sidebarOpen ? 0 : '-100%') : 0,
        top: isMobile ? '70px' : 0,
        height: isMobile ? 'calc(100vh - 70px)' : 'auto',
        zIndex: 1000,
        transition: 'left 0.3s ease',
        overflowY: 'auto',
      }}>
        <h2 style={{ padding: '0 24px', marginBottom: '24px', fontSize: '20px' }}>
          Admin Panel
        </h2>

        <nav>
          <Link
            to="/admin"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <LayoutDashboard size={20} />
            <span>Dashboard</span>
          </Link>

          <Link
            to="/admin/users"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <Users size={20} />
            <span>Users</span>
          </Link>

          <Link
            to="/admin/business-applications"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <Briefcase size={20} />
            <span>Business Accounts</span>
          </Link>

          <Link
            to="/admin/items"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <Package size={20} />
            <span>Items</span>
          </Link>

          <Link
            to="/admin/reports"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <Flag size={20} />
            <span>Reports</span>
          </Link>

          <Link
            to="/admin/transactions"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <CreditCard size={20} />
            <span>Transactions</span>
          </Link>

          <Link
            to="/admin/promos"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <Megaphone size={20} />
            <span>Promos</span>
          </Link>

          <Link
            to="/admin/themes"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <Palette size={20} />
            <span>Themes</span>
          </Link>

          <Link
            to="/admin/settings"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <Settings size={20} />
            <span>Settings</span>
          </Link>

          <Link
            to="/admin/api-tools"
            onClick={() => isMobile && setSidebarOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 24px',
              transition: 'background-color 0.2s',
            }}
          >
            <Code size={20} />
            <span>API Tools</span>
          </Link>
        </nav>
      </aside>

      {/* Overlay for mobile when sidebar is open */}
      {isMobile && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 999,
          }}
        />
      )}

      {/* Main Content */}
      <main style={{
        flex: 1,
        padding: isMobile ? '60px 12px 24px' : '40px',
        width: '100%',
        maxWidth: '100%',
        overflowX: 'auto',
      }}>
        <Routes>
          <Route path="/" element={<DashboardTab />} />
          <Route path="/users" element={<UsersTab />} />
          <Route path="/business-applications" element={<AdminBusinessApplications />} />
          <Route path="/items" element={<ItemsTab />} />
          <Route path="/reports" element={<ReportsTab />} />
          <Route path="/transactions" element={<TransactionsTab />} />
          <Route path="/promos" element={<PromosTab />} />
          <Route path="/themes" element={<ThemesTab />} />
          <Route path="/settings" element={<SettingsTab />} />
          <Route path="/api-tools" element={<APIToolsTab />} />
        </Routes>
      </main>
    </div>
  );
};

export default AdminDashboard;
